/**
 * Copyright (c) 2025, CYBRA Corp. All rights reserved.
 */
import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { CartonAuditService, CartonAuditService_StateInfoDto } from "app/services/carton-audit.service";

/**
 * Resolves the current Carton Audit Service state for the dashboard route.
 */
@Injectable({
  providedIn: 'root', // register as singleton service
})
export class CartonAuditStateResolver implements Resolve<CartonAuditService_StateInfoDto | null> {

  constructor(private cartonAuditService: CartonAuditService) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<CartonAuditService_StateInfoDto | null> {
    const serviceId = route.paramMap.get('id');
    if (!serviceId) {
      return null;
    }
    // Use the CartonAuditService to get current state asynchronously
    return await this.cartonAuditService.getCurrentState(serviceId);
  }
}
